import { render, staticRenderFns } from "./EmailBind.vue?vue&type=template&id=1026a0dc&scoped=true"
import script from "./EmailBind.vue?vue&type=script&lang=js"
export * from "./EmailBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026a0dc",
  null
  
)

export default component.exports